import React, { useEffect, useState } from 'react';
import compliance from '../../images/compliance.png';
// Import the actual icon image (replace with your asset)
import icon from '../../images/dollar.png';

function ExploreLeading() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const descriptions = [
    {
      title: 'UNFCC CDM',
      text: 'The United Nations Framework Convention on Climate Change (UNFCCC) Clean Development Mechanism (CDM) is a flexible market-based mechanism aimed at reducing greenhouse gas emissions and promoting sustainable development in developing countries. Under the CDM, projects that reduce emissions in developing countries can earn Certified Emission Reductions (CERs), which can be traded and used by developed countries to meet their emission reduction targets under the Kyoto Protocol. The CDM encourages investment in clean technologies and sustainable development projects in developing countries, while providing financial and technological support from developed countries.',
    },
    {
      title: 'Gold Standard',
      text: 'The Gold Standard is a premium carbon certification standard that ensures projects not only reduce carbon emissions but also contribute to sustainable development. Developed by WWF and other NGOs, it sets high environmental integrity and requires projects to deliver measurable contributions to the UN Sustainable Development Goals. It is widely used for renewable energy, energy efficiency, and forestry projects, providing assurance that carbon credits represent genuine, additional emission reductions.',
    },
    {
      title: 'Verra (VCS)',
      text: 'The Verified Carbon Standard (VCS) by Verra is the world\'s most widely used voluntary greenhouse gas program. It provides a robust framework for certifying carbon credits from projects that reduce emissions, remove carbon, or enhance carbon sequestration. VCS projects undergo rigorous validation and verification to ensure they meet strict criteria for additionality, permanence, and leakage. Over 1,800 projects have been registered under VCS, covering forestry, renewable energy, and industrial processes.',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % descriptions.length);
        setFade(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, [descriptions.length]);

  return (
    <section className="relative w-[1440px] h-[856px] bg-white flex flex-col items-end overflow-hidden mx-auto">
      {/* Heading */}
      <div className="w-[1200px] text-center text-[40px] font-semibold leading-[48px] -mb-48 text-[#141414] mr-10">
        Explore Leading Compliance Frameworks <span className="text-[#0D924F]">Worldwide</span>
      </div>

      {/* Group containing card and image */}
      <div className="relative w-[1137.46px] h-[520px]">
        {/* Compliance Image */}
        <img
          src={compliance}
          alt="Compliance"
          className="absolute right-[120px] top-[216px] w-[802px] rounded-lg backdrop-blur-[10.3466px] object-cover z-0"
        />

        {/* White Card */}
        <div className="absolute -left-[100px] top-[303px] w-[441px] h-[345px] bg-white border-2 border-[#0D924F]  rounded-2xl p-6 flex flex-col gap-4 z-10">
          {/* Icon */}
          <img src={icon} alt="icon" className="w-[38.4px] h-[24px]" />

          {/* Title */}
          <h3 className="font-medium text-[18px] text-[#141414] w-full">
            {descriptions[currentIndex].title}
          </h3>

          {/* Description with fixed height and fade */}
          <div className="w-full h-[220px] overflow-y-auto ">
            <p
              className={`font-normal text-[14px]  text-[#3B3B3B] transition-opacity duration-300 ${
                fade ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {descriptions[currentIndex].text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExploreLeading;